import DosingRow from 'components/DosingRow/DosingRow';
import DosingTitle from 'forms/DosingInfo/DosingTitle/DosingTitle';

const NarcoFixedDosing = () => {
  return (
    <div
      className="tab-pane dosing-form-container"
      id="pills-fixed-1"
      role="tabpanel"
      aria-labelledby="pills-fixed-tab-1"
    >
      <DosingTitle
        title="Fixed XYWAV Dosing"
        subtitle="2 times a night dosing (For Narcolepsy and IH)"
      />
      <DosingRow
        fields={{
          doses: ['rems:fixedDosing:nih:dose:1', 'rems:fixedDosing:nih:dose:2'],
          totalDose: 'rems:fixedDosing:nih:dose:total',
        }}
        withOperators
        wideField
        mobileFullWidth
      />
    </div>
  );
};

export default NarcoFixedDosing;
